import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";

// Components
import { TableV2 } from "#src/commonV2/Table";
import { IDeviceActivityItem } from "#src/services/endpoint/devices/types";

type Props = {
  hostActivityList: IDeviceActivityItem[];
  isLoading: boolean;
  hostActivityCount: number;
  selectedPage: number;
  setSelectedPage: (value: number) => void;
  pageSize: number;
  setPageSize: (value: number) => void;
};

export const ActivityTable = (props: Props) => {
  const {
    hostActivityList,
    isLoading,
    hostActivityCount,
    selectedPage,
    setSelectedPage,
    pageSize,
    setPageSize,
  } = props;

  const { t } = useTranslation("endpoint", { keyPrefix: "devices" });

  // --------------- METHODS ---------------

  const onChangePage = (selectedPage: number) => {
    setSelectedPage(selectedPage);
  };

  const onChangePageSize = (size: number) => {
    setPageSize(size);
    setSelectedPage(1);
  };

  // --------------- RENDER ---------------

  return (
    <TableV2<IDeviceActivityItem>
      options={{
        fitPageHeight: true,
      }}
      data={hostActivityList}
      getRowKey={(item) => item.id.toString()}
      isLoading={isLoading}
      columns={[
        // Activity
        {
          title: t("activities.activity.label"),
          render: (item) => (
            <p className="text-sm font-medium text-gray-v2-900">
              {t(`activities.activity.${item.type}` as any) as string}
            </p>
          ),
        },

        // Actor
        {
          title: t("activities.actor"),
          render: (item) => (
            <p className="text-sm text-gray-v2-600 font-normal">{item.email}</p>
          ),
        },

        // Time
        {
          title: t("activities.time"),
          render: (item) => (
            <p className="text-sm text-gray-v2-600 font-normal">
              {DateTime.fromSeconds(item.created_time).toFormat(
                "HH:mm dd/MM/yyyy"
              )}
            </p>
          ),
        },
      ]}
      pagination={{
        count: hostActivityCount,
        selected: selectedPage,
        onChange: onChangePage,
        size: { value: pageSize, onChange: onChangePageSize },
      }}
    />
  );
};
